module.exports = __webpack_public_path__ + "img/dash4.55ff9dcc.png";